import React from "react";
import { motion } from "framer-motion";
import { PERSONAS } from "../data/content";
import { ASSETS } from "../lib/constants";

const IMG = { Speaker: ASSETS.speaker, Author: ASSETS.author, Drummer: ASSETS.drummer };

export default function PersonaGrid() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 border-t border-white/5" data-testid="persona-section">
      <div className="max-w-7xl mx-auto">
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-primary-c mb-4">One man, three instruments.</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 mt-10 shape-r overflow-hidden">
          {PERSONAS.map((p, i) => (
            <motion.div
              key={p.role}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="bg-bg p-10 md:p-12 min-h-[340px] flex flex-col justify-between relative overflow-hidden group"
              data-testid={`persona-${p.role.toLowerCase()}`}
            >
              {IMG[p.role] && (
                <img src={IMG[p.role]} alt={p.role} className="absolute inset-0 w-full h-full object-cover opacity-20 group-hover:opacity-30 transition-opacity duration-500" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-bg via-bg/80 to-bg/40" />
              <div className="relative">
                <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-fg/40">The</span>
                <h3 className="font-serif text-4xl md:text-5xl tracking-tight text-primary-c">{p.role}</h3>
              </div>
              <p className="relative text-fg/70 leading-relaxed mt-6">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
